import React, { useEffect, useState } from 'react'
import BossDialog from '../../components/BossDialog'
import { Grid, GridColumn } from '@progress/kendo-react-grid'
import { useTranslation } from '../../locale/useTranslation'
import * as API from "../../framework/API/api"
import { toast } from 'react-toastify'
import { CheckboxCell } from '../../framework/forms/helpercomponents/CustomGridCells/CheckBoxCell'

const AmortisationValueReport = (props) => {

    const lang = useTranslation();

    const [gridData, setGridData] = useState([]);
    const [dealRightDetails, setDealRightDetails] = useState({});

    useEffect(() => {
        loadData();
    }, [props.selectedPlanningItem]);

    const loadData = async () => {
        console.log(props.selectedPlanningItem)
        let response = await API.getAmortizationValueReport({
            mediaDealRightID: props.selectedPlanningItem?.MediaDealRight_id
        })

        console.log(response);

        if (!response.success) {
            toast.error(response.message, {
                position: toast.POSITION.TOP_RIGHT
            })
            return;
        }

        setGridData(response.data.data);
        setDealRightDetails(response.data.mediaDealRight);

    }

    return (
        <BossDialog
            title={"Amortisation Value Report"}
            width={"53%"}
            onClose={props.onClose}
        >
            <h1 className="page-title txt-color-bludeDark" style={{ margin : 0}}>
              <i
                className="fa fa-table marlr"
                style={{ fontSize: "20px", color: "GrayText" }}
              ></i>
              <span>{props.selectedPlanningItem?.mediaEpisode?.Title}</span>
            </h1>
            <p style={{ fontSize : "14px", margin : "0px", textAlign : "right" }}>{`${dealRightDetails?.AmortizationRule ? `Amortization Rule : ${dealRightDetails?.AmortizationRule} |` : ""} Budget Amount : ${dealRightDetails?.Amount} | ${dealRightDetails.IsUnlimited ? "Unlimited" : `Exhibitions : ${dealRightDetails?.Exhibitions}`} | Repeats : ${dealRightDetails?.Repeats} `}</p>
            <Grid
                style={{
                    height: "50vh", 
                    marginTop: "5px" 
                }}
                data={gridData}
                resizable={true}
            >
                <GridColumn field="ExhibitionNumber" title={lang.exhibition_no_column}  />
                <GridColumn field="AmortizedValue" title={lang.amortized_value_label} />
                <GridColumn field="Type" title={lang.type_column} />
                <GridColumn field="ExhibitionUsed" title={lang.exhibition_used_label} cell={CheckboxCell}  />
                <GridColumn field="ExhibitionSchedule" title={lang.exhibition_schedule_label} width={280} />
            </Grid>


        </BossDialog>
    )
}

export default AmortisationValueReport